import { render, staticRenderFns } from "./SagasuPeterPan.vue?vue&type=template&id=3b834c48&"
import script from "./SagasuPeterPan.vue?vue&type=script&lang=js&"
export * from "./SagasuPeterPan.vue?vue&type=script&lang=js&"
import style0 from "./SagasuPeterPan.vue?vue&type=style&index=0&id=3b834c48&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports